/* Practiko - barra de busqueda con resultados al escribir + conteo en categorias */
(function(){
  if (window.__pkSearch) return; window.__pkSearch = true;
  var css = ''+
  '.pk-sb{position:relative;z-index:6;background:#0F172A;padding:4px 16px 14px}'+
  '.pk-sb__wrap{position:relative;max-width:760px;margin:0 auto}'+
  '.pk-sb__form{display:flex;align-items:center;gap:10px;height:52px;padding:5px 6px 5px 15px;background:#FFFFFF;border:1px solid #E2E8F0;border-radius:16px;box-shadow:0 8px 24px rgba(15,23,42,.06)}'+
  '.pk-sb__form:focus-within{border-color:#94A3B8}'+
  '.pk-sb__icon{flex:none;display:grid;place-items:center;color:#0F172A}'+
  '.pk-sb__input{flex:1;min-width:0;border:0!important;outline:0!important;box-shadow:none!important;background:transparent!important;font-family:inherit;font-size:16px;font-weight:400;color:#0F172A;padding:0!important;height:100%;border-radius:0!important}'+
  '.pk-sb__input::placeholder{color:#64748B;font-size:14px}'+
  '.pk-sb__input::-webkit-search-cancel-button{display:none}'+
  '.pk-sb__go{flex:none;width:36px;height:36px;border:0;border-radius:50%;background:#0F172A;color:#fff;display:grid;place-items:center;cursor:pointer;padding:0}'+
  '.pk-sb__go:hover{background:#1D4ED8}.pk-sb__go:focus-visible{outline:2px solid #FF7A00;outline-offset:2px}'+
  'body.pk-sb-overlay main>.shopify-section:first-child{margin-top:0!important}'+
  '.pk-sb__panel{position:absolute;left:0;right:0;top:58px;max-height:70vh;overflow-y:auto;background:#fff;border-radius:12px;box-shadow:0 18px 40px -12px rgba(15,23,42,.45);display:none}'+
  '.pk-sb__panel.is-open{display:block}'+
  '.pk-sb__item{display:grid;grid-template-columns:52px 1fr auto;gap:12px;align-items:center;padding:10px 12px;text-decoration:none;color:#0F172A;border-bottom:1px solid #F1F5F9}'+
  '.pk-sb__item:hover,.pk-sb__item[aria-selected="true"]{background:#F8FAFC}'+
  '.pk-sb__thumb{width:52px;height:52px;border-radius:6px;background:#F2F2F2;object-fit:contain;mix-blend-mode:multiply}'+
  '.pk-sb__name{font-size:.92rem;font-weight:600;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}'+
  '.pk-sb__price{font-size:.92rem;font-weight:800;white-space:nowrap}'+
  '.pk-sb__all{display:block;padding:12px;font-size:.9rem;font-weight:700;color:#1D4ED8;text-decoration:none;background:#F8FAFC}'+
  '.pk-sb__all:hover{text-decoration:underline}'+
  '.pk-sb__empty{padding:16px 14px;font-size:.92rem;color:#475569;line-height:1.5}'+
  '.pk-sb__empty a{color:#1D4ED8;font-weight:700}'+
  '.pk-count{display:block;font-size:.8rem;font-weight:500;opacity:.85;margin-top:2px;font-stretch:100%;letter-spacing:0}'+
  '.pk-sb__go-t{display:none}'+
  '@media (min-width:750px){.pk-sb{padding:6px 24px 18px}}'+
  '.pk-hcenter[hidden]{display:none!important}'+
  '@media (min-width:990px){.pk-sb[hidden]{display:none!important}'+
  'header-component .header__row--top .header__columns:has(.pk-hcenter){display:flex!important;align-items:center;gap:40px}'+
  'header-component .header__columns:has(.pk-hcenter)>.header__column--left,header-component .header__columns:has(.pk-hcenter)>.header__column--right{flex:none;width:auto}'+
  'header-component .pk-hcenter{flex:1 1 auto;display:flex;justify-content:center;align-items:center;min-width:0}'+
  'header-component .pk-hcenter .pk-sb__wrap{width:100%;max-width:600px;margin:0 auto}'+
  'header-component .pk-sb__form{height:56px;border-radius:999px;padding:6px 6px 6px 22px;box-shadow:none;border-color:transparent}'+
  'header-component .pk-sb__form:focus-within{border-color:#FF7A00}'+
  'header-component .pk-sb__go{width:auto;height:44px;border-radius:999px;padding:0 22px;background:#F1F5F9;color:#0F172A}'+
  'header-component .pk-sb__go:hover{background:#E2E8F0}'+
  'header-component .pk-sb__go svg{display:none}header-component .pk-sb__go-t{display:inline;font-weight:700;font-size:15px}'+
  'header-component .pk-sb__panel{top:62px;text-align:left}'+
  'header-component search-button{display:none!important}}';
  css += '.pk-sb{padding:2px 16px 10px}'+
    '.pk-sb__form{height:42px;border-radius:12px;padding:3px 4px 3px 12px;gap:8px;box-shadow:none}'+
    '.pk-sb__icon svg{width:17px;height:17px}'+
    '.pk-sb__input::placeholder{font-size:13.5px}'+
    '.pk-sb__go{width:32px;height:32px;border-radius:9px}'+
    '.pk-sb__go svg{width:14px;height:14px}'+
    '.pk-sb__panel{top:48px}'+
    '@media (min-width:750px){.pk-sb{padding:2px 24px 12px}}'+
    '@media (min-width:990px){header-component .pk-hcenter .pk-sb__wrap{max-width:520px}'+
    'header-component .pk-sb__form{height:44px;border-radius:999px;padding:4px 4px 4px 16px}'+
    'header-component .pk-sb__go{height:36px;padding:0 16px;border-radius:999px}'+
    'header-component .pk-sb__go-t{font-size:13.5px!important}'+
    'header-component .pk-sb__panel{top:52px}}';
  css += 'body.pk-has-sb header-component{box-shadow:none!important}'+
    'body.pk-has-sb header-component search-button{display:none!important}'+
    '.pk-sb{padding:0 16px 12px}'+
    '.pk-sb__form{height:42px;border-radius:10px;padding:0 12px;gap:10px;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.12);box-shadow:none;transition:background-color .15s,border-color .15s}'+
    '.pk-sb__icon{color:#94A3B8}'+
    '.pk-sb__input{color:#F8FAFC}'+
    '.pk-sb__input::placeholder{color:#94A3B8}'+
    '.pk-sb__form:focus-within{background:#FFFFFF;border-color:#FFFFFF}'+
    '.pk-sb__form:focus-within .pk-sb__icon{color:#0F172A}'+
    '.pk-sb__form:focus-within .pk-sb__input{color:#0F172A}'+
    '.pk-sb__form:focus-within .pk-sb__input::placeholder{color:#64748B}'+
    '.pk-sb__go{display:none}'+
    '.pk-sb__panel{top:48px}'+
    '@media (min-width:750px){.pk-sb{padding:0 24px 14px}}'+
    '@media (min-width:990px){header-component .pk-hcenter .pk-sb__wrap{max-width:480px}'+
    'header-component .pk-sb__form{height:40px;border-radius:999px;padding:0 4px 0 16px}'+
    'header-component .pk-sb__go{display:inline-flex;align-items:center;height:32px;padding:0 14px;border-radius:999px;background:transparent;color:#CBD5E1}'+
    'header-component .pk-sb__go:hover{background:rgba(255,255,255,.08);color:#fff}'+
    'header-component .pk-sb__form:focus-within .pk-sb__go{color:#0F172A;background:#F1F5F9}'+
    'header-component .pk-sb__go-t{font-size:13px!important;font-weight:600!important}'+
    'header-component .pk-sb__panel{top:48px}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var ICON = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';

  var ARROW = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  function money(cents){ try { return '$' + parseFloat(cents).toFixed(2); } catch(e){ return cents; } }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function build(){
    var anchor = document.getElementById('header-group');
    if (!anchor || document.querySelector('.pk-sb')) return;
    var wrap = document.createElement('div');
    wrap.className = 'pk-sb';
    wrap.innerHTML =
      '<div class="pk-sb__wrap">'+
        '<form class="pk-sb__form" action="/search" method="get" role="search">'+
          '<span class="pk-sb__icon">'+ICON+'</span>'+
          '<input type="hidden" name="type" value="product">'+
          '<label for="pk-sb-q" class="visually-hidden">Buscar productos</label>'+
          '<input id="pk-sb-q" class="pk-sb__input" type="search" name="q" enterkeyhint="search" autocomplete="off" placeholder="¿Qué producto estás buscando?" aria-controls="pk-sb-panel" aria-expanded="false" aria-autocomplete="list">'+
          '<button class="pk-sb__go" type="submit" aria-label="Buscar">'+ARROW+'<span class="pk-sb__go-t">Buscar</span></button>'+
        '</form>'+
        '<div id="pk-sb-panel" class="pk-sb__panel" role="listbox"></div>'+
      '</div>';
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    document.body.classList.add('pk-has-sb');
    (function fit(){ var hs=document.querySelector('#header-group > header'), hc=document.querySelector('header-component'); if(hs&&hc&&hs.offsetHeight===0){ wrap.style.marginTop=hc.offsetHeight+'px'; document.body.classList.add('pk-sb-overlay'); } })();

    var inner = wrap.querySelector('.pk-sb__wrap');
    var mq = window.matchMedia('(min-width:990px)');
    function place(){ var cols = document.querySelector('header-component .header__row--top .header__columns'); var center = cols && cols.querySelector('.pk-hcenter'); if (cols && !center && mq.matches){ center = document.createElement('div'); center.className = 'header__column pk-hcenter'; cols.insertBefore(center, cols.querySelector('.header__column--right')); } if (mq.matches && center){ center.hidden = false; if (inner.parentNode !== center) center.appendChild(inner); wrap.hidden = true; } else { if (inner.parentNode !== wrap) wrap.appendChild(inner); wrap.hidden = false; if (center) center.hidden = true; } }
    place(); if (mq.addEventListener) mq.addEventListener('change', place); else mq.addListener(place);

    var input = wrap.querySelector('.pk-sb__input') || inner.querySelector('.pk-sb__input');
    var panel = inner.querySelector('.pk-sb__panel');
    var timer, ctrl, sel = -1;

    function close(){ panel.classList.remove('is-open'); input.setAttribute('aria-expanded','false'); sel = -1; }
    function open(){ panel.classList.add('is-open'); input.setAttribute('aria-expanded','true'); }
    function items(){ return panel.querySelectorAll('.pk-sb__item, .pk-sb__all'); }
    function mark(){ var it = items(); for (var i=0;i<it.length;i++) it[i].setAttribute('aria-selected', i===sel ? 'true' : 'false'); }

    function render(q, products){
      var all = '/search?type=product&q=' + encodeURIComponent(q);
      if (!products.length){
        panel.innerHTML = '<div class="pk-sb__empty">No encontramos «'+esc(q)+'». Probá con otra palabra o <a href="https://wa.me/50689027528?text='+encodeURIComponent('Hola Practiko, busco: '+q)+'" target="_blank" rel="noopener">preguntanos por WhatsApp</a>.</div>';
      } else {
        panel.innerHTML = products.map(function(p){
          var img = p.image ? p.image + (p.image.indexOf('?')>-1?'&':'?') + 'width=120' : '';
          return '<a class="pk-sb__item" role="option" href="'+p.url+'">'+
            (img ? '<img class="pk-sb__thumb" src="'+img+'" alt="" loading="lazy">' : '<span class="pk-sb__thumb"></span>')+
            '<span class="pk-sb__name">'+esc(p.title)+'</span>'+
            '<span class="pk-sb__price">'+money(p.price)+'</span></a>';
        }).join('') + '<a class="pk-sb__all" role="option" href="'+all+'">Ver todos los resultados de «'+esc(q)+'»</a>';
      }
      sel = -1; open();
    }

    function search(q){
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=hide', ctrl ? {signal: ctrl.signal} : {})
        .then(function(r){ return r.json(); })
        .then(function(d){
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          render(q, ps);
        }).catch(function(){});
    }

    input.addEventListener('input', function(){
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2){ close(); return; }
      timer = setTimeout(function(){ search(q); }, 180);
    });
    input.addEventListener('keydown', function(e){
      var it = items(); if (!panel.classList.contains('is-open') || !it.length) return;
      if (e.key === 'ArrowDown'){ e.preventDefault(); sel = (sel+1) % it.length; mark(); }
      else if (e.key === 'ArrowUp'){ e.preventDefault(); sel = (sel-1+it.length) % it.length; mark(); }
      else if (e.key === 'Enter' && sel > -1){ e.preventDefault(); it[sel].click(); }
      else if (e.key === 'Escape'){ close(); }
    });
    document.addEventListener('click', function(e){ if (!inner.contains(e.target)) close(); });
  }

  function counts(){
    var links = document.querySelectorAll('.collection-card a[href*="/collections/"]');
    links.forEach(function(a){
      if (a.dataset.pkCount) return; a.dataset.pkCount = '1';
      var label = a.querySelector('.visually-hidden') || a;
      var m = a.getAttribute('href').match(/\/collections\/([^/?#]+)/); if (!m) return;
      fetch('/collections/'+m[1]+'.json').then(function(r){ return r.json(); }).then(function(d){
        var n = d && d.collection && d.collection.products_count;
        if (n){ var s = document.createElement('span'); s.className = 'pk-count'; s.textContent = n + (n === 1 ? ' producto' : ' productos'); label.appendChild(s); }
      }).catch(function(){});
    });
  }

  function init(){ build(); counts(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
